const productData = [
  {
    id: 1,
    name: "2026-2027 Academic Diary - Myrtle Green",
    category: "Diaries",
    price: "424.00",
    reviews: "342",
    rating: "4.6",
    image: "/generated/products/1.png",
    homeImage: "/generated/new-arrivals/1.png",
    images: ["/generated/details/1.png"],
    size: ["A5"],
    colors: ["Myrtle Green", "Burgundy", "Mustard"],
    material: "Water-resistant linen bookcloth, Inaset 100gsm FSC® certified paper",
    description: [
      "This 2026–2027 mid year diary is designed with a weekly spread, checklists, trackers and monthly overviews. Everything you need to stay organised through the academic year.",
      "Compact and lightweight, it's the perfect bag-friendly size for life on the go, whether you're heading to lectures, your studio or a classroom.",
      "This planner has a water-resistant linen bookcloth cover, and the premium paper is silky smooth, a joy to write on. Designed with students, creatives and busy minds in mind. Only a small run available, don't miss out."
    ],
    Features: [
      "Water-resistant linen bookcloth cover",
      "Smooth, premium Inaset 100gsm FSC® certified paper",
      "Foil blocked date on front",
      "Blind embossed pittleforestandco mark on back cover",
      "Ribbon bookmark",
      "Easy-to-use wire-o binding in brass",
      "Year overview spread",
      "Month overview spreads",
      "Weekly spreads",
      "Weekly task list",
      "Weekly tracker",
      "Weekly priorities list",
      "Dot grid pages for notes between months and at the back",
      "12-month academic format (August 4th 2026 – August 2nd 2027)",
      "Made in the UK",
      "Size: A5, 210 x 148mm"
    ],
  },
  {
    id: 2,
    name: "2026-2027 Academic Diary - Mulberry Red",
    category: "Diaries",
    price: "424.00",
    reviews: "289",
    rating: "4.7",
    image: "/generated/products/2.png",
    homeImage: "/generated/new-arrivals/2.png",
    images: ["/generated/details/2.png"],
    size: ["A5"],
    colors: ["Mulberry Red", "Myrtle Green", "Mustard"],
    material: "Water-resistant linen bookcloth, Inaset 100gsm FSC® certified paper",
    description: [
      "This 2026–2027 mid year diary is designed with a weekly spread, checklists, trackers and monthly overviews. Everything you need to stay organised through the academic year.",
      "Compact and lightweight, it's the perfect bag-friendly size for life on the go, whether you're heading to lectures, your studio or a classroom.",
      "This planner has a water-resistant linen bookcloth cover, and the premium paper is silky smooth, a joy to write on. Designed with students, creatives and busy minds in mind. Only a small run available, don't miss out."
    ],
    Features: [
      "Water-resistant linen bookcloth cover",
      "Smooth, premium Inaset 100gsm FSC® certified paper",
      "Foil blocked date on front",
      "Blind embossed pittleforestandco mark on back cover",
      "Ribbon bookmark",
      "Easy-to-use wire-o binding in brass",
      "Year overview spread",
      "Month overview spreads",
      "Weekly spreads",
      "Weekly task list",
      "Weekly tracker",
      "Weekly priorities list",
      "Dot grid pages for notes between months and at the back",
      "12-month academic format (August 4th 2026 – August 2nd 2027)",
      "Made in the UK",
      "Size: A5, 210 x 148mm"
    ],
  },
  {
    id: 3,
    name: "2026-2027 Academic Diary - Ochre Yellow",
    category: "Diaries",
    price: "424.00",
    reviews: "214",
    rating: "4.5",
    image: "/generated/products/3.png",
    homeImage: "/generated/new-arrivals/3.png",
    images: ["/generated/details/3.png"],
    size: ["A5"],
    colors: ["Ochre Yellow", "Myrtle Green", "Mulberry Red"],
    material: "Water-resistant linen bookcloth, Inaset 100gsm FSC® certified paper",
    description: [
      "This 2026–2027 mid year diary is designed with a weekly spread, checklists, trackers and monthly overviews. Everything you need to stay organised through the academic year.",
      "Compact and lightweight, it's the perfect bag-friendly size for life on the go, whether you're heading to lectures, your studio or a classroom.",
      "This planner has a water-resistant linen bookcloth cover, and the premium paper is silky smooth, a joy to write on. Designed with students, creatives and busy minds in mind. Only a small run available, don't miss out."
    ],
    Features: [
      "Water-resistant linen bookcloth cover",
      "Smooth, premium Inaset 100gsm FSC® certified paper",
      "Foil blocked date on front",
      "Blind embossed pittleforestandco mark on back cover",
      "Ribbon bookmark",
      "Easy-to-use wire-o binding in brass",
      "Year overview spread",
      "Month overview spreads",
      "Weekly spreads",
      "Weekly task list",
      "Weekly tracker",
      "Weekly priorities list",
      "Dot grid pages for notes between months and at the back",
      "12-month academic format (August 4th 2026 – August 2nd 2027)",
      "Made in the UK",
      "Size: A5, 210 x 148mm"
    ],
  },
  {
    id: 4,
    name: "2026-2027 Weekly Academic Planner - Abstract Terra",
    category: "Planners",
    price: "255.00",
    reviews: "178",
    rating: "4.6",
    image: "/generated/products/4.png",
    homeImage: "/generated/new-arrivals/4.png",
    images: ["/generated/details/4.png"],
    size: ["A5"],
    colors: ["Celine No.1"],
    material: "250gsm hammered texture cover, 90gsm music sheet paper",
    description: [
      "Meet your new desk companion: the 2026–2027 Academic Planner in our original Abstract Terra design. It runs from August 2026 to July 2027 and features monthly overviews and weekly spreads to keep your schedule in check.",
      "With 12 note pages tucked inside, there's plenty of space for lists, musings and sudden strokes of genius.",
      "The cover is printed on 250gsm card with a beautiful hammered texture that softens over time, wearing in like a favourite pair of jeans.",
      "When you're not using it, style it up on your shelf. It's as good-looking as it is practical."
    ],
    Features: [
      "A5 academic planner",
      "Runs from August 2026 to July 2027",
      "Weekly and monthly spreads",
      "12 note pages",
      "144 pages of 90gsm music sheet paper",
      "250gsm hammered texture cover",
      "Layflat OTA binding",
      "Ribbon bookmark included",
      "Designed and made in the UK",
      "Packed by hand in London",
      "Size: (14.8 x 21 cm)"
    ],
  },
  {
    id: 5,
    name: "2026-2027 Academic Year Task Planner - Matcha",
    category: "Planners",
    price: "424.00",
    reviews: "305",
    rating: "4.8",
    image: "/generated/products/5.png",
    images: ["/generated/details/5.png"],
    size: ["7.5\" × 9.5\""],
    colors: ["Matcha"],
    material: "Water-resistant book cloth cover, 70 lb text-weight stock",
    description: [
      "Improve your academic planning with the pittleforestandco 2026–2027 Academic Year Task Planner in Matcha. Its easy-to-use, thoughtfully minimal layout is designed for students, professionals and creatives.",
      "These Academic Planners are just bigger than A5, but smaller than A4, making them a great size for slipping into a book bag when zipping between your daily activities.",
      "Each double page spread includes a weekly view on the left and a full page on the right for highlighting your priorities, making notes and composing a task list. It even has tickable check boxes for satisfying completion. Laminated monthly tabs allow for easy navigation throughout the year.",
      "This luxurious planner features a water-resistant book cloth cover, brass wire-o binding and a subtly foil-stamped cover.",
      "The Academic Year Task Planner is dated and runs from August 2026 - July 2027."
    ],
    Features: [
      "Water-resistant book cloth cover",
      "Smooth, premium 70 lb text-weight stock",
      "Laminated month tabs",
      "Foil stamped covers",
      "Brass wire-o binding",
      "One lined page for notes at the end of each month",
      "Year overview",
      "Conversion chart",
      "Monthly goals",
      "Monthly spread, including key holidays",
      "Week & tasks spread",
      "Aug 2026 - July 2027",
      "12-month",
      "7.5\" × 9.5\"",
      "0.6\" product depth",
      "158 pages",
      "1.16 lbs",
      "Size: 7.5\" × 9.5\""
    ],
  },
  {
    id: 6,
    name: "Gardening Journal - Olive Green",
    category: "Journals",
    price: "212.00",
    reviews: "198",
    rating: "4.4",
    image: "/generated/products/6.png",
    images: ["/generated/details/6.png"],
    size: ["A5"],
    colors: ["Olive Green"],
    material: "Hardcover, thick smooth pages",
    description: [
      "This gardening journal is a useful notebook full of prompts and layouts built for planning, tracking, and reflecting on your garden's journey. Whether you're planting your first seeds or fine-tuning a thriving oasis, this journal helps you stay organised while embracing the joy of growing."
    ],
    Features: [
      "Olive Green bold printed hardcover design",
      "Comprehensive layout with a garden planner, plant journal, watering schedule, and expense tracker",
      "Dedicated sections to record planting schedules, growth milestones, and daily reflections",
      "Premium hardback cover with bold floral artwork, designed to inspire and last",
      "Easy-to-use templates for beginners and also detailed enough for experienced growers",
      "High-quality materials with thick, smooth pages and a ribbon bookmark",
      "Thoughtfully designed because great gardens start with clear planning",
      "Size: A5 (148 x 210mm)"
    ],
  },
  {
    id: 7,
    name: "2026-2027 Academic Diary - A5 / Stripes Pink",
    category: "Diaries",
    price: "265.00",
    reviews: "240",
    rating: "4.7",
    image: "/generated/products/7.png",
    images: ["/generated/details/7.png"],
    size: ["A5"],
    colors: ["Stripes Pink"],
    material: "Hardcover with soft-touch finish, cream-colored paper",
    description: [
      "An 18-month diary designed to bring clarity to a busy academic year.",
      "Full of handy checklists and plenty of room for to do's, not to do's, goals, brilliant ideas, dream jobs, festivals to visit, and much more! In short, more than enough space for all your creative ideas. The handy diary to get everything out of life without losing control. With this journal for 2026/2027 you won't forget anything and you will whistle through the new academic year."
    ],
    Features: [
      "Hardcover with soft-touch finish",
      "A5 size",
      "Weekly and monthly overviews",
      "Elastic closure",
      "Packed with helpful checklists",
      "Ribbon bookmark",
      "Convenient storage envelope",
      "Cream-colored paper",
      "FSC Certified",
      "Plenty of space for notes",
      "Covers: June 29, 2026, to January 2, 2028"
    ],
  },
  {
    id: 8,
    name: "2026-2027 Academic Diary - A5 / Blue Bordeaux",
    category: "Diaries",
    price: "265.00",
    reviews: "190",
    rating: "4.8",
    image: "/generated/products/8.png",
    images: ["/generated/details/8.png"],
    size: ["A5"],
    colors: ["Blue Bordeaux"],
    material: "Hardcover with soft-touch finish, cream-colored paper",
    description: [
      "An 18-month diary designed to bring clarity to a busy academic year.",
      "Full of handy checklists and plenty of room for to do's, not to do's, goals, brilliant ideas, dream jobs, festivals to visit, and much more! In short, more than enough space for all your creative ideas. The handy diary to get everything out of life without losing control. With this journal for 2026/2027 you won't forget anything and you will whistle through the new academic year."
    ],
    Features: [
      "Hardcover with soft-touch finish",
      "A5 size",
      "Weekly and monthly overviews",
      "Elastic closure",
      "Packed with helpful checklists",
      "Ribbon bookmark",
      "Convenient storage envelope",
      "Cream-colored paper",
      "FSC Certified",
      "Plenty of space for notes",
      "Covers: June 29, 2026, to January 2, 2028"
    ],
  },
  {
    id: 9,
    name: "2026-2027 My Journal School Diary - Lavender Blue",
    category: "Diaries",
    price: "233.00",
    reviews: "256",
    rating: "4.7",
    image: "/generated/products/9.png",
    images: ["/generated/details/9.png"],
    size: ["A5"],
    colors: ["Lavender Blue"],
    material: "Hardcover with soft-touch finish, cream-colored paper",
    description: [
      "The student- and school diary 2026-2027 which perfectly controls that busy life of yours.",
      "Full of handy checklists and plenty of room for to do's, not to do's, goals, brilliant ideas, dream jobs, festivals to visit, and much more! In short, more than enough space for all your creative ideas. The handy diary to get everything out of life without losing control. With this journal for 2026/2027 you won't forget anything and you will whistle through the new academic year."
    ],
    Features: [
      "Hardcover with soft-touch finish",
      "A5 size",
      "Weekly and monthly overviews",
      "Elastic closure",
      "Packed with helpful checklists",
      "Ribbon bookmark",
      "Convenient storage envelope",
      "Cream-colored paper",
      "FSC Certified",
      "Plenty of space for notes",
      "Covers: July 20, 2026 – September 05, 2027"
    ],
  },
  {
    id: 10,
    name: "Reading Journal - Read More Books",
    category: "Journals",
    price: "212.00",
    reviews: "312",
    rating: "4.9",
    image: "/generated/products/10.png",
    images: ["/generated/details/10.png"],
    size: ["A5"],
    colors: ["Green"],
    material: "Hardcover, 100 GSM pure white paper",
    description: [
      "The cover of this Reading Journal features a delightful blend of soft pastels, with a charming motif that evokes a sense of adventure and creativity. The friendly typography invites you to dive into your reading journey, making it a lovely addition to your bookshelf or a thoughtful gift for a book lover.",
      "Inside, you'll find a series of well-organised sections designed to help you reflect on your reading experiences, track what you've read, and plan your next literary adventures. This journal beautifully combines creativity with functionality, inspiring memory-keeping and thoughtful reflection."
    ],
    Features: [
      "A5 size makes it portable for all your reading adventures.",
      "Sewn binding ensures durability, allowing you to cherish it for years.",
      "One bookmark ribbon helps you easily find your last entry.",
      "Crafted with 100 GSM pure white paper, it's perfect for writing.",
      "Thoughtfully designed to enhance your reading experience and inspire reflection."
    ],
  },
  {
    id: 11,
    name: "Pocket Notebook - Mulberry Red",
    category: "Notebooks",
    price: "149.00",
    reviews: "198",
    rating: "4.6",
    image: "/generated/products/11.png",
    images: ["/generated/details/11.png"],
    size: ["A6"],
    colors: ["Mulberry Red"],
    material: "270gsm British-made cover, 100gsm wood-free paper",
    description: [
      "Say hello to the pittleforestandco Pocket Notebook. It measures a neat 148 x 105mm in a convenient A6 format.",
      "We designed it for people who like to travel light but still want a dependable notebook close at hand. Its slim profile slips easily into a bag or jacket pocket, ready to catch ideas, sketches or lecture notes whenever inspiration strikes.",
      "The cover comes in Mulberry Red. Understated detailing keeps it refined, with a blind-embossed pittleforestandco mark on the back and a small tactile leaf emblem on the front.",
      "Inside, you'll find 80 smooth, ruled pages printed with lightweight lines, spaced 6mm apart. The stock is FSC certified, designed to handle fountain pens without feathering or bleed-through, and the pages are threadsewn for durability and ease of use. Each notebook is printed and bound in Buckinghamshire by a fourth-generation, family-run bindery. We're launching with a limited run of 100 in each colourway."
    ],
    Features: [
      "270gsm British-made cover in Mulberry Red, produced in the Lake District",
      "80 threadsewn ruled pages, printed with lightweight lines at 6mm spacing",
      "100gsm wood-free, FSC certified, fountain-pen-friendly inner stock",
      "Printed and bound in Buckinghamshire, UK, by a fourth-generation family-run bindery",
      "Designed by pittleforestandco",
      "Size: A6 (148 x 105mm)"
    ],
  },
  {
    id: 12,
    name: "Shell Pink Notebook",
    category: "Notebooks",
    price: "255.00",
    reviews: "267",
    rating: "4.5",
    image: "/generated/products/12.png",
    images: ["/generated/details/12.png"],
    size: ["A5"],
    colors: ["Shell Pink"],
    material: "270gsm British made cover, 100gsm wood-free paper",
    description: [
      "Inspired by the soft tones and tactile surfaces of tiny shoreline shells, the subtly textured cover adds a natural, refined finish.",
      "Shell Pink is a light pink A5 notebook with 236 pages. Choose dot grid, ruled or plain.",
      "The notebook begins with a simple printed bookplate for dedicating to your pal, or putting your reward and contact information. We've all got to do our bit to help lost notebooks find their way back home.",
      "Two contents pages and numbered pages throughout allow for easy navigation. As you move through the notebook, the page numbers gradually change colour, taking you through the spectrum.",
      "The notebook contains smooth 100gsm fountain-pen-friendly paper with minimal show-through. It is suitable for highlighters, rollerballs, brush pens, ballpoints, ink pens, graphite and coloured pencils. Alcohol-based markers may show through more easily.",
      "We've used lay flat binding so the notebook opens without forcing the spine. This binding method backlines the inner pages within the spine, leaving them free to move. The cover is bound on with front and rear hinges only.",
      "The cover is subtly blind embossed with the pittleforestandco mark on the back and a small leaf emblem on the front."
    ],
    Features: [
      "A5 notebook",
      "240 FSC certified paper pages",
      "2 x contents pages",
      "1 x bookplate page",
      "236 x A5 pages with 6mm rules, 5mm dot grid or plain pages",
      "Numbered pages",
      "Chunky spine at 15mm thick",
      "270gsm British made cover, produced in the Lake District",
      "100gsm, wood free, fountain pen friendly inner stock",
      "Printed and bound in Buckinghamshire, United Kingdom, by a fourth-generation, family-run binder.",
      "Designed by pittleforestandco",
      "Size: A5, 148mm x 205mm"
    ],
  },
  {
    id: 13,
    name: "Wiro Bound Notebook - Wisteria Purple",
    category: "Notebooks",
    price: "424.00",
    reviews: "223",
    rating: "4.6",
    image: "/generated/products/13.png",
    images: ["/generated/details/13.png"],
    size: ["A5"],
    colors: ["Wisteria Purple"],
    material: "Real linen bookcloth cover, 100gsm cream paper",
    description: [
      "Our Wisteria purple wire bound notebook comes in a fresh lavender hue, rich and optimistic. Adds a subtle pop of colour to your desk and day. Finished with a bone ribbon bookmark that gives it a modern edge.",
      "This notebook is all about ease, from the wire binding to the smooth, bright cream pages that resist ink bleed. Choose your layout and fill it your way.",
      "The card backing is light enough to carry around, but tough enough to handle daily use. With dot grid, ruled or plain paper to choose from, and a lay-flat binding so no space goes to waste."
    ],
    Features: [
      "Real linen bookcloth cover",
      "176 pages",
      "Lay-flat brass wire binding",
      "Smooth, cream 100gsm FSC® certified paper",
      "Choose from dot grid, ruled or plain pages",
      "Bereford, UK Made Bone-coloured ribbon marker",
      "Lightweight but sturdy card backing",
      "Made in the UK",
      "Size: A5, 210 x 148mm"
    ],
  },
  {
    id: 14,
    name: "365 Days Ruled Notebook - Black / A5",
    category: "Notebooks",
    price: "339.00",
    reviews: "198",
    rating: "4.7",
    image: "/generated/products/14.png",
    images: ["/generated/details/14.png"],
    size: ["A5"],
    colors: ["Black"],
    material: "Coated paper and cloth cover, super light fountain pen friendly paper",
    description: [
      "A clean, spacious notebook designed for everyday writing and long-form notes.",
      "This A5 notebook contains super light, fountain pen friendly paper and a coated cloth and paper cover.",
      "365 was originally designed for editors who write down vast amounts of information everyday. Essentially, they needed a whole page for each day, but in a clean and spacious format without a limiting predefined structure.",
      "The ruled paper is subtle and the paper feels bible-thin, so it's light enough to carry around.",
      "Suitable for use as a journal, notebook or sketchbook"
    ],
    Features: [
      "Made in Japan",
      "Coated paper and cloth cover",
      "368 pages / 184 sheets / Ruled",
      "Size: 148 x 210mm"
    ],
  },
  {
    id: 15,
    name: "A5 Notebook Band - Grey",
    category: "Accessories",
    price: "85.00",
    reviews: "312",
    rating: "4.8",
    image: "/generated/products/15.png",
    images: ["/generated/details/15.png"],
    size: ["A5"],
    colors: ["Grey"],
    material: "Czech elastic",
    description: [
      "An elasticated loop for your pens in grey. This band fits horizontally around an A5 notebook, diary or book.",
      "Keep those pens from rolling away – our playful and ingenious elasticated pen loop in black keeps the sides of your notebooks and all your writing implements together!",
      "They are made from Czech elastic by a team of seamstresses working in home workshops near the town of Lidice.",
      "These notebook bands hold the pages of notepads safely together while keeping up to five pens - pull them over your writing pads, hold your school jotters together, or just keep them loose in your bag",
      "This Noteband Strap is also available in A4 and A6 sizes here."
    ],
    Features: [
      "Elasticated loop for your pens",
      "Fits horizontally around an A5 notebook, diary or book",
      "Made from Czech elastic",
      "Made by a team of seamstresses working in home workshops near the town of Lidice",
      "Holds up to five pens",
      "Also available in A4 and A6 sizes"
    ],
  },
  {
    id: 16,
    name: "Everyday Pen - Mulberry Red",
    category: "Pens",
    price: "101.00",
    reviews: "187",
    rating: "4.7",
    image: "/generated/products/16.png",
    images: ["/generated/details/16.png"],
    size: ["One size"],
    colors: ["Mulberry Red"],
    material: "Natural cedar wood casing, brass accents, black oil-based ink",
    description: [
      "The Everyday Pen in Mulberry Red.",
      "Our Everyday Pen is a hybrid that brings together smooth flowing ink, like that found in a fountain or rollerball, with the ease of use found with a Ballpoint. It's manufactured in Japan, the birthplace of the rollerball pen, by a factory who have been creating pens for over 70 years. So we're in good hands.",
      "A needle-like 0.5mm tip creates an ultra fine writing line. We often hear you guys ooh-ing and ah-ing when you first test out a needle-point, and for good reason. Rather than the conventional conical tip found on your typical rollerball, the needle-point is a pipe shape. The 3mm length makes it easy to see when writing, and it's so precise you can even use it with a ruler. When coupled with a smooth ink, it's a match made in handwriting heaven.",
      "Our factory just so happen to be experts in ink manufacturing with over one hundred years of ink-making under their belt. Our pen has a soft ink which is black, oil-based and low-viscosity. It has one of the deepest densities of colour you'll find on the market which results in excellent coverage and minimal reflection. As you move the pen across your page, the low-viscosity ink means it feels soft and flows freely, but with more control than you'd find with a rollerball or fountain pen. Soft ink creates very dark, precise and clear lines which work beautifully for drawing and writing. These qualities also make it a good choice for scanning and copying.",
      "The natural cedar wood body feels as lightweight as a pencil. A mulberry coating and subtle brass accents give the retractable design a warm, refined finish, completed with a small pittleforestandco mark.",
      "The Everyday Pen is refillable. You can purchase your refills here. Check out the other colours in our Everyday collection here.",
      "How to refill your pen",
      "It's easy! Twist the pointy, nib end of your pen - not the push button! It will loosen easily. Remove the spring and the existing refill. Slide your fresh refill in, removing the protective bobble on the tip. Slide the spring back in until you meet resistance. Place the pointy section back onto the end of the pen and screw until secure. Hey presto, you're ready to roll!"
    ],
    Features: [
      "Manufactured in Japan by a factory with over 70 years of pen-making experience",
      "Needle-like 0.5mm tip creates an ultra fine writing line",
      "Soft ink which is black, oil-based and low-viscosity",
      "Natural cedar wood casing",
      "Brass knock with matching brass taper",
      "Subtly finished with the pittleforestandco mark",
      "Refillable",
      "Also available in other colours"
    ],
  },
  {
    id: 17,
    name: "Pocket Pen - Oxide Rose",
    category: "Pens",
    price: "75.00",
    reviews: "234",
    rating: "4.6",
    image: "/generated/products/17.png",
    images: ["/generated/details/17.png"],
    size: ["One size"],
    colors: ["Oxide Rose"],
    material: "Anodised aluminium body with steel components",
    description: [
      "Small, precise, and thoughtfully engineered, the Oxide Rose Pocket Pen is a micro-sized retractable pen developed with our Japanese partners for its balance and refined scale. The anodised aluminium body keeps it exceptionally lightweight, while the steel tip offers accuracy and control when writing.",
      "Finished in Oxide Rose, a muted metallic rose. The colour brings a soft warmth to this compact design - understated, distinctive, and easy to spot in a pocket or pencil case.",
      "Product details",
      "Length: 91mm",
      "Weight: 3.1g",
      "Material: anodised aluminium body with steel components",
      "Mechanism: push end to extend, side push to retract",
      "Refill: 0.5mm needlepoint ballpoint (black ink)",
      "Refillable",
      "Made in Japan for pittleforestandco",
      "Small, polished, ready to write."
    ],
    Features: [
      "Micro-sized retractable pen",
      "Length: 91mm",
      "Weight: 3.1g",
      "Anodised aluminium body with steel components",
      "Push end to extend, side push to retract",
      "0.5mm needlepoint ballpoint refill (black ink)",
      "Refillable",
      "Made in Japan for pittleforestandco"
    ],
  },
  {
    id: 18,
    name: "Studio Pen - Mushroom",
    category: "Pens",
    price: "159.00",
    reviews: "201",
    rating: "4.6",
    image: "/generated/products/18.png",
    images: ["/generated/details/18.png"],
    size: ["One size"],
    colors: ["Shroom"],
    material: "Light aluminium base, brass hardware",
    description: [
      "Introducing the Studio Pen, a refined arrival to the pittleforestandco collection that is comfortable to write with, balanced to hold and easy on the eye.",
      "Featured here in Mushroom, this pen pairs a lightweight aluminium body with brass hardware and supports interchangeable gel or ballpoint refills for a comfortable everyday writing experience.",
      "With refillable ink, this Pen keeps giving. It comes with the choice of two black ink options with additional refills available to purchase separately. Choose from soft-oiled ballpoint ink or fluid gel ink. The gel pen has a fine tip of 0.5mm and the ballpoint has a 0.7mm tip. With both pen refills, you have the option to angle for a thicker line. It's super easy to pop in each refill and change the ink to your preference whenever you fancy a switch.",
      "Available in a spectrum of six softly polished colours inspired by woodland earth, stone and changing light.",
      "You can buy additional refills for ballpoint ink here, or gel ink here."
    ],
    Features: [
      "Black Ink",
      "Six colour options",
      "Ballpoint and Gel tip refills",
      "0.7mm and 0.5mm tip",
      "Light aluminium base",
      "Brass hardware",
      "Available in six colours",
      "Size: 1.12 x 0.9 x 13.64 cm"
    ],
  },
  {
    id: 19,
    name: "Everyday Pen - Lunar Blue",
    category: "Pens",
    price: "101.00",
    reviews: "276",
    rating: "4.8",
    image: "/generated/products/19.png",
    images: ["/generated/details/19.png"],
    size: ["One size"],
    colors: ["Lunar Blue"],
    material: "Natural cedar wood casing, brass accents, black oil-based ink",
    description: [
      "The Everyday Pen in Lunar Blue.",
      "Our Everyday Pen is a hybrid that brings together smooth flowing ink, like that found in a fountain or rollerball, with the ease of use found with a Ballpoint. It's manufactured in Japan, the birthplace of the rollerball pen, by a factory who have been creating pens for over 70 years. So we're in good hands.",
      "A needle-like 0.5mm tip creates an ultra fine writing line. We often hear you guys ooh-ing and ah-ing when you first test out a needle-point, and for good reason. Rather than the conventional conical tip found on your typical rollerball, the needle-point is a pipe shape. The 3mm length makes it easy to see when writing, and it's so precise you can even use it with a ruler. When coupled with a smooth ink, it's a match made in handwriting heaven.",
      "Our factory just so happen to be experts in ink manufacturing with over one hundred years of ink-making under their belt. Our pen has a soft ink which is black, oil-based and low-viscosity. It has one of the deepest densities of colour you'll find on the market which results in excellent coverage and minimal reflection. As you move the pen across your page, the low-viscosity ink means it feels soft and flows freely, but with more control than you'd find with a rollerball or fountain pen. Soft ink creates very dark, precise and clear lines which work beautifully for drawing and writing. These qualities also make it a good choice for scanning and copying.",
      "The natural cedar wood body feels as lightweight as a pencil. A lunar blue coating and subtle brass accents give the retractable design a calm, refined finish, completed with a small pittleforestandco mark.",
      "The Everyday Pen is refillable. You can purchase your refills here. Check out the other colours in our Everyday collection here.",
      "How to refill your pen",
      "It's easy! Twist the pointy, nib end of your pen - not the push button! It will loosen easily. Remove the spring and the existing refill. Slide your fresh refill in, removing the protective bobble on the tip. Slide the spring back in until you meet resistance. Place the pointy section back onto the end of the pen and screw until secure. Hey presto, you're ready to roll!"
    ],
    Features: [
      "Manufactured in Japan by a factory with over 70 years of pen-making experience",
      "Needle-like 0.5mm tip creates an ultra fine writing line",
      "Soft ink which is black, oil-based and low-viscosity",
      "Natural cedar wood casing",
      "Brass knock with matching brass taper",
      "Subtly finished with the pittleforestandco mark",
      "Refillable",
      "Also available in other colours"
    ],
  },
  {
    id: 20,
    name: "Pocket Pen Refill",
    category: "Refills",
    price: "22.00",
    reviews: "189",
    rating: "4.6",
    image: "/generated/products/20.png",
    images: ["/generated/details/20.png"],
    size: ["One size"],
    colors: ["Black"],
    material: "Refill",
    description: [
      "This is the refill for our Pocket Pen."
    ],
    Features: [
      "0.5mm needlepoint ballpoint refill",
      "Black ink",
      "For use with Pocket Pen",
      "Made in Japan"
    ],
  },
  {
    id: 21,
    name: "Daily Desktop Planner Pad - Misty Pink",
    category: "Planners",
    price: "212.00",
    reviews: "0",
    rating: "5.0",
    image: "/generated/products/21.png",
    images: ["/generated/details/21.png"],
    size: ["A4"],
    colors: ["Misty Pink"],
    material: "110gsm paper, 80% recycled fibres, greyboard backing",
    description: [
      "Our first desktop planning collection has landed at pittleforestandco.",
      "A 'Focus' space invites you to set an intention or goal for your week.",
      "There's a space for creating a parent list of top priorities and key tasks for the week. Each day of the week has a fluid structure with space for noting daily tasks or your schedule - whatever suits you. The handy tick boxes allow you to check off tasks with a real pen - ah, the satisfaction of getting things done. The 'Do Later' box encourages you to set aside your lower priority tasks and new ideas."
    ],
    Features: [
      "A4 gummed, tear-off pad",
      "Designed for pittleforestandco",
      "60 sheets",
      "110gsm weight paper stock",
      "Made with 80% recycled fibres",
      "FSC® certified, acid free, elemental chlorine free paper",
      "Fully recyclable and biodegradable",
      "Pink / Butter Yellow paper printed with burnt orange ink",
      "Sturdy greyboard backing with a subtle pittleforestandco mark",
      "Comes without any unnecessary packaging"
    ],
  },
];

export default productData;
